import React, { useState, useEffect } from 'react';

const RecordPaymentModal = ({ isOpen, onClose, onSave, invoice }) => {
    // --- FIX: All hooks are now at the top level ---
    const [amountPaid, setAmountPaid] = useState('');
    const [paymentDate, setPaymentDate] = useState('');
    const [notes, setNotes] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // This effect resets the form state whenever the modal is opened
    useEffect(() => {
        if (isOpen && invoice) {
            setAmountPaid(invoice.amount_due || '');
            setPaymentDate(new Date().toISOString().split('T')[0]);
            setNotes('');
        }
    }, [isOpen, invoice]);

    // The early return now happens AFTER the hooks have been called
    if (!isOpen) {
        return null;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await onSave({ amountPaid, paymentDate, notes });
            onClose(); // Close modal on success
        } catch (error) {
            alert(`Failed to save payment: ${error.message}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Record Payment for Invoice #{invoice.id}</h2>
                <p><strong>Customer:</strong> {invoice.customer_name}</p>
                <p><strong>Amount Due:</strong> ${parseFloat(invoice.amount_due).toFixed(2)}</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Amount Paid</label>
                        <input className="form-input" type="number" step="0.01" value={amountPaid} onChange={e => setAmountPaid(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Payment Date</label>
                        <input className="form-input" type="date" value={paymentDate} onChange={e => setPaymentDate(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <label className="form-label">Notes (Optional)</label>
                        <textarea className="form-input" value={notes} onChange={e => setNotes(e.target.value)} />
                    </div>
                    <div className="modal-actions">
                        <button type="button" className="button button-secondary" onClick={onClose} disabled={isSubmitting}>Cancel</button>
                        <button type="submit" className="button action-button" disabled={isSubmitting}>
                            {isSubmitting ? 'Saving...' : 'Save Payment'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RecordPaymentModal;